import { Editor } from "@monaco-editor/react";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import PromptModal from "./PromptModel";
import ResponseModel from "./ResponseModel";
import ConfirmationModal from "../ConfirmationModal";
import { Models, PromptGeneraterName } from "../UserDetails";
import { PostGeneratePrompt, PostStorePrompt } from "../apis/post";
import {
  ArrowLeftRight,
  ChevronLeft,
  ChevronRight,
  RefreshCcw,
} from "lucide-react";

type ManualMatchProcessMainModelProps = {
  isOpen: boolean;
  title?: string;
  data: any;
  // onClose: () => void;
  // onSubmit: (response: string, queue: boolean) => void;
  // step: number;
  // setStep: (_step: number) => void;
  models: Models;
  setModels: (value: any) => void;
};

type StepType = {
  title: string;
  description: string;
  id: number;
};

const MATCH_MAKING_STEPS: Record<string, StepType> = {
  "1": {
    title: "Astroloyg",
    description: "",
    id: 3,
  },
  "2": {
    title: "Tag Pair",
    description: "",
    id: 6,
  },
  "3": {
    title: "Commentary",
    description: "",
    id: 5,
  },
  "4": {
    title: "Summary",
    description: "",
    id: 4,
  },
};

const ManualMatchProcessMainModel: React.FC<
  ManualMatchProcessMainModelProps
> = ({ isOpen, title = "Provide Your Response", data, models, setModels }) => {
  const [input, setInput] = useState("");
  const [prompt, setPrompt] = useState("");
  // const [copied, setCopied] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState<number>(1);
  const [reverseView, setReverseView] = useState(false);
  const [user, setUser] = useState(data.uid);
  const [candidate, setCandidate] = useState(data.cid);

  const generatePrompt = async (_id: any, _uid: string, _cid: string) => {
    try {
      const data = {
        userId: _uid,
        candidateUserId: _cid,
        promptType: _id,
      };
      const response = await PostGeneratePrompt(data);
      // const response: any = {status: "success", message: "Prompt generated", prompt: {"prompt_type": "astro_summary"}, response: {"response": "Astroogy"}}

      if (response.status == "success") {
        setPrompt(response.prompt);
        setInput(JSON.stringify(response.response));
        // setInput(response.response);
        // setInput(JSON.parse(response.response));
        return true;
      } else if (response.message?.toLowerCase().includes("no tags found")) {
        // setConfirmModal(true);
        toast.error("no tags allocated to user or candidate");
        return false;
      } else {
        setPrompt("Failed to fetch.");
        setInput("");

        return false;
      }
    } catch (error: any) {
      return false;
    }
  };

  const storePrompt = async (promptResponse: any, _id: any) => {
    try {
      const data = {
        userId: user.userId,
        candidateUserId: candidate.userId,
        promptResponse: promptResponse,
        promptType: _id,
      };
      const response = await PostStorePrompt(data);
      // const response = {
      //   status: "success",
      //   message: "Stored",
      // };

      if (response.message.includes("saved as eliminate")) {
        // removeRowByUserId(_candidateUserId);
        // setMatchMakingStep(1);
        // setShowMatchMakingModal(false);
        // window.location.reload();
      }

      if (response.status == "success") {
        console.log("Stored", data);
        return true;
      } else {
        return false;
      }
    } catch (error: any) {
      return false;
    }
  };

  const handleFetchPrompt = async (_id: any) => {
    setPrompt("Fetching...");
    setInput("");
    const res: boolean = await generatePrompt(
      _id,
      user.userId,
      candidate.userId
    );
    if (res) {
    }
  };

  const handleBack = async () => {
    if (step != 1) {
      setStep(step - 1);
      await handleFetchPrompt(MATCH_MAKING_STEPS[step - 1].id);
    }
  };

  const handleNext = async () => {
    // setReverseView(false);
    // if (!reverseView) {
    //   setModels((prev: Models) => ({ ...prev, popUpCandidate: true }));
    //   return;
    // } else {
    //   handleReverseButton();
    // }
    await handleFetchPrompt(MATCH_MAKING_STEPS[step + 1].id);
    setStep(step + 1);
  };

  const handleReverseButton = () => {
    setReverseView(!reverseView);
    // setUser(reverseView ? data.cid : data.uid);
    // setCandidate(!reverseView ? data.cid : data.uid);
  };

  useEffect(() => {
    if (isOpen && user.userId && candidate.userId) {
      handleFetchPrompt(MATCH_MAKING_STEPS[step].id);
    }
  }, [user, candidate, isOpen]);

  useEffect(() => {
    if (isOpen) {
      setUser(reverseView ? data.cid : data.uid);
      setCandidate(!reverseView ? data.cid : data.uid);
    }
  }, [reverseView, isOpen]);

  const handleSubmit = async () => {
    if (input.trim() === "") {
      toast.error("Please provide a response.");
      setLoading(false);
      return;
    }

    try {
      JSON.parse(input);
      const res = await storePrompt(input, MATCH_MAKING_STEPS[step].id);
      if (res) {
        if (step < 4) {
          setModels((prev: Models) => ({ ...prev, popUpSubmit: false }));
          setInput("");
          // if (!reverseView) {
          //   setModels((prev: Models) => ({ ...prev, popUpCandidate: true }));
          //   return;
          // } else {
          //   handleReverseButton();
          // }
        } else {
          setModels((prev: Models) => ({
            ...prev,
            popUpSubmit: false,
            manaulMatchProcessMainModal: false,
          }));
          setStep(1);
          setPrompt("");
          setInput("");
        }
      }
    } catch (err) {
      toast.error("Invalid JSON format.");
    }
  };

  if (!isOpen) return null;

  if (!user || !candidate) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center backdrop-blur-sm">
      <div className="bg-white/10 backdrop-blur-lg border border-white/20 text-white rounded-xl shadow-xl w-full max-w-6xl p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">
            {MATCH_MAKING_STEPS[step].title} {"  >>>"}{" "}
            <span className="text-gray-400">
              {reverseView ? "Reverse" : "Original"} Queue
            </span>
            <span className="block text-sm font-medium text-gray-300 mt-2">
              <span className="text-yellow-500 tracking-[0.10rem]">
                {user?.name}
              </span>
              <span className="text-gray-400 text-sm tracking-wide"> - </span>
              <span className="text-yellow-500 tracking-[0.10rem]">
                {candidate?.name}
              </span>
              <span className="text-gray-200">
                {" (" + user?.userId + " - " + candidate?.userId + ")"}
              </span>
            </span>
          </h2>
          <div className="flex gap-8">
            <button
              onClick={async () => {
                handleReverseButton();
                await handleFetchPrompt(MATCH_MAKING_STEPS[step].id);
              }}
              className="bg-yellow-300 text-black font-semibold px-2.5 py-0.5 text-sm rounded hover:bg-yellow-400 transition w-full"
            >
              <div className="flex gap-4 content-center">
                <span>
                  <ArrowLeftRight className="h-4 w-4" />
                </span>{" "}
                <span>{!reverseView ? "Reverse" : "Original"}</span>
              </div>
            </button>

            <button
              onClick={async () => {
                await handleFetchPrompt(MATCH_MAKING_STEPS[step].id);
              }}
              className="bg-yellow-300 text-black font-semibold px-2.5 py-0.5 text-sm rounded hover:bg-yellow-400 transition"
            >
              <RefreshCcw className="h-4 w-4" />
            </button>
            <button
              onClick={() => {
                setModels((prev: Models) => ({ ...prev, popUpCancel: true }));
              }}
              className="text-gray-300 hover:text-red-400 text-2xl font-bold transition"
            >
              &times;
            </button>
          </div>
        </div>

        {/* Prompt Display */}
        <PromptModal prompt={prompt} />

        {/* JSON Editor */}
        <ResponseModel input={input} setInput={(value) => setInput(value)} />

        {/* Footer Buttons */}
        <div className="flex justify-end gap-3 mt-5">
          {step !== 1 && (
            <button
              onClick={async () => await handleBack()}
              className="px-4 py-2 rounded text-white text-sm backdrop-blur-md bg-blue-500/10 hover:bg-blue-500/20 border border-blue-500/30 shadow-md transition"
            >
              <div className="flex gap-4 content-center">
                <span>
                  <ChevronLeft className="h-5 w-5" />
                </span>{" "}
                <span>Back</span>
              </div>
            </button>
          )}

          <button
            onClick={() => {
              setModels((prev: Models) => ({ ...prev, popUpCancel: true }));
            }}
            className="px-4 py-2 rounded text-white text-sm backdrop-blur-md bg-red-500/10 hover:bg-red-500/20 border border-red-500/30 shadow-md transition"
          >
            Cancel
          </button>

          <button
            onClick={() => {
              if (input.trim() === "") {
                toast.error("Please provide a response.");
                setLoading(false);
                return;
              }

              setModels((prev: Models) => ({ ...prev, popUpSubmit: true }));
            }}
            disabled={loading}
            className={`px-4 py-2 text-sm font-semibold rounded backdrop-blur-md transition ${
              loading
                ? "bg-yellow-300/20 text-black cursor-not-allowed border border-yellow-300/30 shadow-inner"
                : "bg-green-400/20 text-green-100 hover:bg-green-300/30 border border-green-300/30 shadow-md hover:shadow-lg"
            }`}
          >
            {loading ? (
              <svg
                className="animate-spin h-4 w-4 mx-auto text-black"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                />
              </svg>
            ) : (
              "Submit"
            )}
          </button>

          {step < 4 && (
            <button
              onClick={() => {
                handleNext();
              }}
              className="px-4 py-2 rounded text-white text-sm backdrop-blur-md bg-blue-500/10 hover:bg-blue-500/20 border border-blue-500/30 shadow-md transition"
            >
              <div className="flex gap-4 content-center">
                <span>Next</span>
                <span>
                  <ChevronRight className="h-5 w-5" />
                </span>{" "}
              </div>
            </button>
          )}
        </div>
      </div>

      {/* Modal for Submit Button */}
      <ConfirmationModal
        isOpen={models.popUpSubmit}
        onClose={() => {
          setModels((prev: Models) => ({ ...prev, popUpSubmit: false }));
        }}
        // onClose={setModels((prev: Models) => ({ ...prev, popUp: false, manaulMatchProcessMainModal: false }))}
        title={"Confirm Submission"}
        description={
          "Are you sure you want to submit your response? This action cannot be undone."
        }
        onConfirm={async () => {
          await handleSubmit();
        }}
        variant="green"
      />

      {/* Model for Cancel Button */}
      <ConfirmationModal
        isOpen={models.popUpCancel}
        onClose={() => {
          setModels((prev: Models) => ({ ...prev, popUpCancel: false }));
        }}
        title={"Confirm Close Modal"}
        description={
          "Are you sure you want to close this modal? This action cannot be undone."
        }
        onConfirm={() => {
          setModels((prev: Models) => ({
            ...prev,
            popUpCancel: false,
            manaulMatchProcessMainModal: false,
          }));
          setStep(1);
          setPrompt("");
          setInput("");
          setReverseView(false);
          setUser({});
          setCandidate({});
        }}
        variant="danger"
      />
      {/* Model for Candidate Matching Button */}
      <ConfirmationModal
        isOpen={models.popUpCandidate}
        onClose={async () => {
          setModels((prev: Models) => ({ ...prev, popUpCandidate: false }));
          setPrompt("");
          setInput("");

          if (!(step < 4)) {
            setModels((prev: Models) => ({
              ...prev,
              popUpSubmit: false,
              manaulMatchProcessMainModal: false,
            }));
            setStep(1);
            setPrompt("");
            setInput("");
          } else {
            await handleFetchPrompt(MATCH_MAKING_STEPS[step + 1].id);
            setStep(step + 1);
          }
        }}
        title={
          "Want to submit " + MATCH_MAKING_STEPS[step].title + " for Candidate."
        }
        description={
          "Are you sure you want to submit " +
          MATCH_MAKING_STEPS[step].title +
          " for Candidate  (" +
          candidate.name +
          ") ?"
        }
        onConfirm={async () => {
          setModels((prev: Models) => ({
            ...prev,
            popUpCandidate: false,
          }));

          // toggle the revese button
          handleReverseButton();
          setPrompt("");
          setInput("");
          // await handleFetchPrompt(MATCH_MAKING_STEPS[step].id);
        }}
      />
    </div>
  );
};

export default ManualMatchProcessMainModel;
